import React, { useEffect } from 'react';
import { LogOut, UserCircle } from 'lucide-react';
import { useAuth } from '../../AuthContext';
import { useParams, useNavigate } from 'react-router-dom';
import { cn } from '../../../lib/utils';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '../../ui/dropdown-menu';

const UserDropdown = ({ sidebar = false, expanded = true }) => {
  const { tenantDomain } = useParams();
  const { user, updateTenantDomain } = useAuth();
  const navigate = useNavigate();
  const userObj = user;

  const initials = userObj?.name
    ? userObj.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  useEffect(() => {
    updateTenantDomain(tenantDomain);
  }, [tenantDomain, updateTenantDomain]);

  const handleLogout = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/logout/`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        navigate(tenantDomain ? `/${tenantDomain}/login` : '/install');
      } else {
        console.error('Logout failed:', response.statusText);
      }
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (sidebar) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className={cn(
            "flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors w-full focus:outline-none",
          )}>
            <div className="flex items-center justify-center w-[17px] h-[17px] rounded-full bg-primary text-primary-foreground text-[9px] font-bold shrink-0">
              {initials}
            </div>
            {expanded && (
              <span className="truncate">{userObj?.name || userObj?.email || 'Account'}</span>
            )}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent side="right" align="end" sideOffset={8}>
          {userObj?.userId && (
            <DropdownMenuItem onClick={() => navigate(`/${tenantDomain}/user/${userObj.userId}`)}>
              <UserCircle size={16} />
              Profile
            </DropdownMenuItem>
          )}
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleLogout} className="text-destructive focus:text-destructive">
            <LogOut size={16} />
            Logout
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center justify-center w-8 h-8 rounded-full text-white hover:bg-white/20 transition-colors focus:outline-none">
          <div className="flex items-center justify-center w-7 h-7 rounded-full bg-white/20 text-white text-xs font-bold">
            {initials}
          </div>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {userObj?.userId && (
          <DropdownMenuItem onClick={() => navigate(`/${tenantDomain}/user/${userObj.userId}`)}>
            <UserCircle size={16} />
            Profile
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} className="text-destructive focus:text-destructive">
          <LogOut size={16} />
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserDropdown;
